//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../../views/common-components/file-uploader';
import { formatDate } from '../../../../src/lib/date';
import SelectProjectModal from '../components/select-project-modal';

export default {
    name: 'onSaleDetail',
    components: {
        SelectProjectModal, fileUploader
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        var vm = this;
        return {
            louShuInfo: {},
            loading: false,
            huXingList: [],
            id: 0,
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '类型',
                    key: 'type',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showHuXing(row);
                                }
                            }
                        }, row.type));
                        return h('div', actions);
                    }
                },
                {
                    title: '面积（㎡）',
                    key: 'area',
                    align: 'center'
                },
                {
                    title: '单价（元/㎡）',
                    key: 'price',
                    align: 'center'
                },
                {
                    title: '操作',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        var del = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.delHuXing(params.row);
                                }
                            }
                        }, '删除');

                        actions.push(h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.editHuXing(params.row);
                                }
                            }
                        }, '编辑'));
                        actions.push(del);
                        return h('div', actions);
                    }
                }

            ],
            huXing: { image: { associateType: 'HuXingImage' } },
            showEditHuXingModal: false,
            huXingRules: {
                type: { required: true, message: '请输入类型', trigger: 'blur' },
                area: { required: true, type: 'number', message: '请输入面积', trigger: 'blur' },
                price: { required: true, type: 'number', message: '请输入单价', trigger: 'blur' }
            },
            saving: false,
            showHuXingModal: false,
            showEditLouShuModal: false,
            louShu: {
                file: { associateType: 'LouShuFile' }
            },
            louShuRules: {
                projectName: { required: true, message: '不能为空', trigger: 'blur' },
                name: { required: true, message: '不能为空', trigger: 'blur' }
            },
            showAddProjectModal: false
        };
    },
    methods: {
        getLouShu() {
            this.loading = true;
            abp.ajax.get('/api/services/app/LouShu/GetLouShuById?id=' + this.id).then(res => {
                if (res.data.result != null) {
                    this.louShuInfo = {};
                    this.louShuInfo = res.data.result;

                    this.louShu = {};
                    this.louShu = JSON.parse(JSON.stringify(res.data.result));
                    this.louShu.file = { associateType: 'LouShuFile' };
                    this.getHuXingList(this.louShuInfo.id);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        getHuXingList(lid) {
            abp.ajax.post('/api/services/app/LouShu/HuXingList?louShuId=' + lid).then(res => {
                this.huXingList = [];
                this.huXingList.push(...res.data.result.items);
            }).finally(() => {
            });
        },
        editHuXing(hu) {
            this.huXing = {};
            this.huXing = hu;
            this.huXing.image = { associateType: 'HuXingImage' };
            this.showEditHuXingModal = true;
        },
        cancel() {
            this.saving = false;
            this.showEditHuXingModal = false;
        },
        saveHuXing() {
            this.huXing.louShuId = this.louShuInfo.id;
            var vm = this;
            this.$refs.huxingForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/LouShu/SaveHuXing', vm.huXing).then(res => {
                        vm.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        this.getLouShu();
                        this.showEditHuXingModal = false;
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        delHuXing(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除该户型吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    abp.ajax.delete('/api/services/app/LouShu/DeleteHuXingById?id=' + row.id).then(res => {
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        this.getLouShu();
                    }).finally(() => {

                    });
                }
            });
        },
        showHuXing(row) {
            this.huXing = {};
            this.huXing = row;
            this.huXing.image = { associateType: 'HuXingImage' };
            this.showHuXingModal = true;
        },
        showAddProject() {
            this.showAddProjectModal = true;
        },
        addProject(data) {
            console.log(data);
            const vm = this;
            vm.louShu.projectId = data.id;
            vm.louShu.projectName = data.name;
            vm.louShu.address = data.address;
            vm.showAddProjectModal = false;
        },
        onSaveLouShu() {
            var vm = this;
            this.$refs.loushuForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    abp.ajax.post('/api/services/app/LouShu/SaveLouShu', vm.louShu).then(res => {
                        vm.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        this.showEditLouShuModal = false;
                        this.getLouShu();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        deLouShu() {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    abp.ajax.delete('/api/services/app/LouShu/DeleteLouShuById?id=' + vm.id).then(res => {
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        // this.getLouShu();
                        vm.$router.back();
                    }).finally(() => {

                    });
                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.getLouShu();
    }
};
